import * as Types from "../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchNearbyLocationIdsQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
  longitude: Types.Scalars["Float"]["input"];
  latitude: Types.Scalars["Float"]["input"];
  region: Types.Scalars["String"]["input"];
}>;

export type FetchNearbyLocationIdsQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    locationsNearest?: {
      __typename?: "BookableLocationsConnection";
      nodes: Array<{__typename?: "BookableLocation"; id: string}>;
    } | null;
  } | null;
};

export const FetchNearbyLocationIdsDocument = gql`
  query FetchNearbyLocationIds(
    $practiceId: ID!
    $longitude: Float!
    $latitude: Float!
    $region: String!
  ) {
    practice(id: $practiceId) {
      id
      locationsNearest(first: 3, longitude: $longitude, latitude: $latitude, region: $region) {
        nodes {
          id
        }
      }
    }
  }
`;

/**
 * __useFetchNearbyLocationIdsQuery__
 *
 * To run a query within a React component, call `useFetchNearbyLocationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNearbyLocationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNearbyLocationIdsQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      longitude: // value for 'longitude'
 *      latitude: // value for 'latitude'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useFetchNearbyLocationIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchNearbyLocationIdsQuery,
    FetchNearbyLocationIdsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<FetchNearbyLocationIdsQuery, FetchNearbyLocationIdsQueryVariables>(
    FetchNearbyLocationIdsDocument,
    options,
  );
}
export function useFetchNearbyLocationIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchNearbyLocationIdsQuery,
    FetchNearbyLocationIdsQueryVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<FetchNearbyLocationIdsQuery, FetchNearbyLocationIdsQueryVariables>(
    FetchNearbyLocationIdsDocument,
    options,
  );
}
export type FetchNearbyLocationIdsQueryHookResult = ReturnType<
  typeof useFetchNearbyLocationIdsQuery
>;
export type FetchNearbyLocationIdsLazyQueryHookResult = ReturnType<
  typeof useFetchNearbyLocationIdsLazyQuery
>;
export type FetchNearbyLocationIdsQueryResult = Apollo.QueryResult<
  FetchNearbyLocationIdsQuery,
  FetchNearbyLocationIdsQueryVariables
>;
